import { Button } from "src/global/ui/Button/Button.tsx"
import { styled } from "styled-components"
import { Image } from "src/global/ui/Image"
import { EXPECTATION_PROMPT_TEXT } from "src/pages/DataAssets/views/Expectations/SimpleExpectationDrawer/ExpectationPrompt/words"

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`

type Props = {
  onClick: () => void
  disabled: boolean
  loading: boolean
}

export function GenerateExpectationButton({ onClick, disabled, loading }: Props) {
  const icon = <Image type="sparkles" aria-label="Generate SQL" svgProps={{ height: "16px", width: "16px" }} />

  return (
    <ButtonContainer>
      <Button
        type="default"
        icon={icon}
        onClick={onClick}
        disabled={disabled}
        loading={loading}
        data-testid="generate-expectation-button"
        style={{ display: "flex", alignItems: "center" }}
      >
        {EXPECTATION_PROMPT_TEXT.BUTTON}
      </Button>
    </ButtonContainer>
  )
}
